/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Store script.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 */
var Store = {
    buy: function (type, id) {
        Api.post("/store/buy", { item: type, id: id }, function (r) {
            if (r.success) {
                Store.update(
                    r.coins,
                    r.afro,
                    r.achievement,
                    r.renamings,
                    r.tokens,
                    r.giftsRecoveries,
                );
                switch (type) {
                    case "afro":
                        //AFRO
                        var success =
                            "Has comprado satisfactoriamente %AMOUNT% días de Afro.".replace(
                                "%AMOUNT%",
                                r.days,
                            );
                        break;
                    case "achievement":
                        //ACHIEVEMENTS
                        var success =
                            "Has comprado satisfactoriamente el logro %ACH_NAME%.".replace(
                                "%ACH_NAME%",
                                r.name,
                            );
                        $(".b_ach-" + id)
                            .removeClass("green")
                            .addClass("red disabled")
                            .html(
                                '<span class="glyphicons glyphicons-shopping-cart"></span> ' +
                                    strings[1],
                            );
                        break;
                    case "renamings":
                        //RENAMINGS
                        var success =
                            "Has comprado un cambio de nombre exitosamente. Puedes utilizarlo yendo al apartado de cuenta cuando desees.";
                        $(".buy_renamings")
                            .removeClass("green")
                            .addClass("red disabled")
                            .html(
                                '<span class="glyphicons glyphicons-shopping-cart"></span> Comprado',
                            );
                        break;
                    case "effect":
                        //EFFECT
                        var success =
                            "¡Ha comprado satisfactoriamente un efecto de nick!";
                        $(".buy_effect-" + id)
                            .removeClass("green")
                            .addClass("red disabled")
                            .html(
                                '<span class="glyphicons glyphicons-shopping-cart"></span> Comprado',
                            );
                        break;
                    case "slot":
                        var success =
                            "¡Enhorabuena! El espacio de armario de nick ha sido añadido a tu cuenta.";
                        break;
                    case "icon":
                        //ICON
                        var success =
                            "¡Ha comprado satisfactoriamente un ícono de nick!";
                        $(".buy_icon-" + id)
                            .removeClass("green")
                            .addClass("red disabled")
                            .html(
                                '<span class="glyphicons glyphicons-shopping-cart"></span> Comprado',
                            );
                        break;
                    case "sticker":
                        var success =
                            "¡Has sumado el sticker a tu colección satisfactoriamente! Gracias por tu compra.";
                        $(".buy_sticker-" + id)
                            .removeClass("green")
                            .addClass("red disabled")
                            .html(
                                '<span class="glyphicons glyphicons-shopping-cart"></span> Comprado',
                            );
                        break;
                    case "background":
                        var success =
                            "¡Has comprado el fondo web satisfactoriamente!";
                        $(".buy_background-" + id)
                            .removeClass("green")
                            .addClass("red disabled")
                            .html(
                                '<span class="glyphicons glyphicons-shopping-cart"></span> Comprado',
                            );
                        break;
                    case "avatarDecoration":
                        var success =
                            "¡Has comprado la decoración de avatar satisfactoriamente!";
                        $(".b_frame-" + id)
                            .removeClass("green")
                            .addClass("red disabled")
                            .html(
                                '<span class="glyphicons glyphicons-shopping-cart"></span> Comprado',
                            );
                        break;
                    case "clubgiftrecovery":
                        var success =
                            "¡Has comprado el boleto de recuperación de regalo Club Afro satisfactoriamente!";

                        break;
                }
                Alert.push([{ type: "success", text: success, icon: "check" }]);
            } else {
                switch (r.error.identifier) {
                    case "insufficient_coins":
                        //NO COINS
                        Alert.push([
                            {
                                type: "danger",
                                text: "No tienes monedas suficientes para realizar la compra.",
                                icon: "triangle-alert",
                            },
                        ]);
                        $(".buy_" + type).each(function () {
                            $(this)
                                .removeClass("green")
                                .addClass("red disabled");
                        });
                        break;
                    case "no_query":
                        //NOT FOUND
                        Alert.push([
                            {
                                type: "danger",
                                text: "El servicio que intentas comprar no está disponible.",
                                icon: "triangle-alert",
                            },
                        ]);
                        break;
                    case "already_exists":
                        //ALREADY EXISTS
                        Alert.push([
                            {
                                type: "danger",
                                text: "Ya compraste anteriormente este %ITEM%".replace(
                                    "%ITEM%",
                                    type == "achievement"
                                        ? "logro"
                                        : type == "renamings"
                                          ? "cambio de nombre"
                                          : "efecto",
                                ),
                                icon: "triangle-alert",
                            },
                        ]);
                        break;
                    case "wrong_item":
                        //ITEM DOES NOT EXIST
                        Alert.push([
                            {
                                type: "danger",
                                text: "El servicio que intentas comprar no existe.",
                                icon: "triangle-alert",
                            },
                        ]);
                        break;
                    case "exceed_count_items":
                        Alert.push([
                            {
                                type: "danger",
                                text: "Ya has adquirido la cantidad máxima de items disponibles.",
                                icon: "triangle-alert",
                            },
                        ]);
                        document.getElementById("wardrobe_buy_item").remove();
                        break;
                    case "recovery_limit_exceeded":
                        Alert.push([
                            {
                                type: "danger",
                                text: "Ya has adquirido la cantidad máxima de boletos de recuperación de regalo Club Afro disponibles.",
                                icon: "triangle-alert",
                            },
                        ]);

                        $(".buy_clubgiftrecovery")
                            .removeClass("green")
                            .addClass("red disabled");

                        break;
                }
            }
        });
    },

    update: function (coins, afro, achievement, renamings, tokens, recoveries) {
        if (coins != undefined)
            $("#account_coins").html(
                number_format(
                    parseInt($("#account_coins").html().replace(/\./g, "")) +
                        parseInt(coins),
                    0,
                    ",",
                    ".",
                ),
            );

        if (tokens != undefined)
            $("#accounts_tokens").html(
                number_format(
                    parseInt($("#accounts_tokens").html().replace(/\./g, "")) +
                        parseInt(tokens),
                    0,
                    ",",
                    ".",
                ),
            );

        if (afro != undefined)
            Language.get([
                [
                    "accounts.store_afro_days",
                    { NUMBER: Math.ceil(afro / 86400) },
                ],
            ]).then(function (strings) {
                $("#account_afro").html(strings[0]);
            });

        if (achievement != undefined)
            $("#account_achievements").html(
                parseInt($("#account_achievements").html()) + 1,
            );

        if (renamings != undefined)
            $("#account_renamings").html(
                parseInt($("#account_renamings").html()) + 1,
            );

        if (recoveries != undefined)
            $("#accounts_recoveries").html(
                parseInt($("#accounts_recoveries").html()) + 1,
            );
    },
};

/* Voucher */
var Voucher = {
    redeem: function () {
        $("#store_redeem").submit(function (e) {
            e.preventDefault();
            Api.post(
                "/vouchers/redeem",
                {
                    voucher: $("#store_redeem_string")
                        .attr("disabled", true)
                        .val(),
                },
                function (r) {
                    if (!r.error) {
                        $("#store_redeem_string").val("");
                        Alert.push([
                            {
                                type: "success",
                                text: "El código ha sido canjeado exitosamente.",
                                icon: "ok-circle",
                            },
                        ]);
                        Store.update(
                            r.coins,
                            r.afro,
                            r.achievement,
                            r.renamings,
                            r.furni,
                        );
                    } else {
                        switch (r.error.identifier) {
                            case "not_found":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "El código que has introducido no existe o ya ha sido canjeado por alguien más.",
                                        icon: "triangle-alert",
                                    },
                                ]);
                                break;
                            case "param_null":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "El campo de texto del código está vacío.",
                                        icon: "triangle-alert",
                                    },
                                ]);
                                break;
                        }
                    }
                    $("#store_redeem_string").attr("disabled", false);
                },
            );
        });
    },
};
